import { Box, Grid } from '@mui/material';
import TextField from '@mui/material/TextField';
import { ChangeEventHandler } from 'react';
import AddAnexos from "../addAnexos";
import { CountryDropdown } from "react-country-region-selector";


const useStyles = () => ({
    gridItem: { margin: 8 },
    formContainer: {
        padding: 16
    },
});

interface FormDataProps {
    formData: {
        nomeProduto: string;
        nomeComercial: string;
        numeroLote: string;
        dataFabrico: string;
        dataExpiracao: string;
        nomeFabricante: string;
        paisOrigem: string;
        fornecedor: string;
        dataRecepcao: string;
    };
    handleChange: ChangeEventHandler<HTMLInputElement>;
    setFormData?: Function;
}

const IdentificaçãoProduto = ({ formData, setFormData, handleChange }: FormDataProps) => {
    const classes = useStyles();
    return (
        <Box style={classes.formContainer}>

            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <TextField
                        required
                        type="text"
                        label="Nome do produto (DCI)"
                        fullWidth
                        size="small"
                        name="nomeProduto"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.nomeProduto}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                        required
                        type="text"
                        label="Nome comercial"
                        fullWidth
                        size="small"
                        name="nomeComercial"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.nomeComercial}
                    />
                </Grid>
                <Grid item xs={12} md={6} >
                    <TextField
                        required
                        type="text"
                        label="Número do lote"
                        fullWidth
                        size="small"
                        name="numeroLote"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.numeroLote}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                        required
                        type="date"
                        label="Data de Fábrico"
                        fullWidth
                        size="small"
                        name="dataFabrico"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.dataFabrico}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                        required
                        type="date"
                        label="Data de Expiração"
                        fullWidth
                        size="small"
                        name="dataExpiracao"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.dataExpiracao}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                        required
                        type="text"
                        label="Nome do fabricante"
                        fullWidth
                        size="small"
                        name="nomeFabricante"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.nomeFabricante}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    {/* <TextField
                        required
                        type="text"
                        label="País de origem"
                        fullWidth
                        size="small"
                        name="paisOrigem"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.paisOrigem}
                    /> */}

                        <CountryDropdown
    
                            {...({
                                style: { width: '100%', height: '40px', paddingLeft: '10px', fontSize: '16px', borderColor: 'rgba(0, 0, 0, 0.23)', borderRadius: '4px'}
                              } as any)}
                            
                            value={formData?.paisOrigem ?? ""}
                            onChange={(pais) =>
                                setFormData && setFormData((prevData: any) => ({
                                    ...prevData,
                                    paisOrigem: pais
                                }))
                            }
                            defaultOptionLabel="Pais de Origem"
                        />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        required
                        type="text"
                        label="Nome do distribuidor / fornecedor"
                        fullWidth
                        size="small"
                        name="fornecedor"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.fornecedor}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextField
                        required
                        type="date"
                        label="Data da recepção"
                        fullWidth
                        size="small"
                        name="dataRecepcao"
                        variant="outlined"
                        onChange={handleChange}
                        value={formData.dataRecepcao}
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
            </Grid>

            <AddAnexos formData={formData} setFormData={setFormData} />
        </Box>
    )
}

export default IdentificaçãoProduto
